import React from "react";
import { Link } from "react-router-dom";

const getPublicAsset = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;

  const publicUrl = process.env.PUBLIC_URL || "";
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${publicUrl}${normalizedPath}`;
};

const ProductOverview = ({ overview }) => {
  if (!overview) return null;

  const {
    image,
    imageAlt,
    eyebrow,
    title,
    specs = [],
  } = overview;

  return (
    <section className="product-overview" aria-label={title}>
      <div className="product-overview__image-panel">
        {eyebrow && (
          <span className="product-overview__eyebrow">{eyebrow}</span>
        )}
        <img
          src={getPublicAsset(image)}
          alt={imageAlt || title}
          className="product-overview__image"
        />
      </div>

      <div className="product-overview__content">
        <h2 className="product-overview__title">{title}</h2>

        {/* Product pricing is prepared in data and intentionally hidden until pricing display is approved. */}
        {/* {(price || compareAtPrice || discountText) && (
          <div className="product-overview__pricing">
            {compareAtPrice && (
              <span className="product-overview__compare-price">
                {compareAtPrice}
              </span>
            )}
            {price && <span className="product-overview__price">{price}</span>}
            {discountText && (
              <span className="product-overview__discount">{discountText}</span>
            )}
          </div>
        )} */}

        {/* {note && <p className="product-overview__note">{note}</p>} */}

        {/* Product purchase actions are prepared in data and intentionally hidden until checkout/cart flows are enabled. */}
        {/* {actions.length > 0 && (
          <div className="product-overview__actions">
            {actions.map((action) => {
              const variantClass =
                action.variant === "outline"
                  ? "product-overview__button--outline"
                  : "product-overview__button--solid";
              const className = `product-overview__button ${variantClass}`;

              if (action.modalTarget) {
                return (
                  <button
                    type="button"
                    className={className}
                    data-bs-toggle="modal"
                    data-bs-target={action.modalTarget}
                    key={action.label}
                  >
                    {action.label}
                  </button>
                );
              }

              if (!action.to) {
                return (
                  <button type="button" className={className} key={action.label}>
                    {action.label}
                  </button>
                );
              }

              return (
                <Link to={action.to} className={className} key={action.label}>
                  {action.label}
                </Link>
              );
            })}
          </div>
        )} */}

        {specs.length > 0 && (
          <dl className="product-overview__specs">
            {specs.map((spec) => (
              <div className="product-overview__spec" key={spec.label}>
                <dt>{spec.label}</dt>
                <dd>
      {spec.value === "LiFePO" ? (
        <>
          LiFePO<sub>4</sub>
        </>
      ) : (
        spec.value
      )}
    </dd>
              </div>
            ))}
          </dl>
        )}
      </div>
    </section>
  );
};

export default ProductOverview;
